import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { postRequest } from '../../../../setup/redux/common/cruds'
import { Loader } from '../../../services/Loader'
import { AuthFooter } from '../../../services/Functional'
import { AuthSidePanel } from './AuthSidePanel'
import FAIcon from '../../../../_metronic/helpers/components/FAIcon'
import { faUser } from '@fortawesome/free-solid-svg-icons'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Email is required'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<any>(null)
  const [message, setMessage] = useState<any>(null)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values: any, { resetForm, setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        const payload: any = {
          email: values.email,
        }
        postRequest(`${process.env.REACT_APP_API_BASE_URL}auth/forgot-password`, payload)
          .then((response) => {
            if (response.data.success) {
              setHasErrors(false)
              resetForm()
              setMessage(null)
            }
            else {
              setHasErrors(true)
              setMessage(response.data.message)
            }
            setLoading(false)
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  return (
    <>
      {loading && <Loader />}
      <div className='row w-100 h-100 p-0 m-0'>
        <div className='col-md-7 p-0 bg-white position-relative'>
          <div className='mx-auto d-flex justify-content-center align-items-center h-100'>
            <form className='auth_form form_align' id='login_form' noValidate onSubmit={formik.handleSubmit}>
              <div className='mb-6 animate__animated animate__fadeInUp'>
                <h2 className='font-weight-bold'>Forgot Password</h2>
                <div className='fs-4'>Enter your email to reset your password.</div>
              </div>
              {hasErrors === true && (
                <div className='mb-6 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>
                    {message ? message : "Sorry, looks like there are some errors detected, please try again."}
                  </div>
                </div>
              )}

              {hasErrors === false && (
                <div className='mb-6 bg-light-info p-8 rounded'>
                  <div className='text-info'>Please check your email for a password reset link.</div>
                </div>
              )}

              <div className='form-group mb-6 animate__animated animate__fadeInUp'>
                <input
                  type='email'
                  placeholder='Ex: someone@email.com'
                  autoComplete='off'
                  {...formik.getFieldProps('email')}
                  className={clsx(
                    'form-control login_input',
                    {
                      'is-invalid': formik.touched.email && formik.errors.email,
                    },
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                />
                <FAIcon icon={faUser} className='left-icon' />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.email as string}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className='animate__animated animate__fadeInUp'>
                <button disabled={loading} type='submit' className='btn btn-primary me-3'>
                  <span className='indicator-label'>Submit </span>
                </button>
                <Link to='/auth/login'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-light-primary'
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </form>
            <AuthFooter />
          </div>
        </div>
        <div className='col-md-5 p-0 background_card overflow-hidden position-relative'>
          <AuthSidePanel />
        </div>
      </div>
    </>
  )
}
